import {
  ConsentResource,
  consentResource
} from '@witkac/kartamiejska-resources';
import { Consent } from '@witkac/kartamiejska-shared';

import { SessionStorage } from '@/enums/sessionStorage.enum';
import { AbstractModule } from './abstract.module';

/**
 * Moduł zgód
 *
 * @export
 * @class ConsentsModule
 * @extends {AbstractModule<ConsentResource>}
 */
export class ConsentsModule extends AbstractModule<ConsentResource> {
  public state = {
    accepted: []
  };

  public actions = {
    /**
     * Pobiera zgody zalogowanego użytkownika
     *
     * @param {*} context
     * @returns {Promise<void>}
     */
    accepted: (context: any): Promise<void> => {
      return this.resource
        .list({
          count: -1,
          userId: sessionStorage.getItem(SessionStorage.USER_ID)
        } as any)
        .then(consents => context.commit('saveAccepted', consents.list));
    }
  };
  public mutations = {
    /**
     * Zapisuje zgody
     *
     * @param {*} localState
     * @param {Consent[]} list
     */
    saveAccepted(localState: any, list: Consent[]): void {
      localState.accepted = list;
    }
  };
}

export default new ConsentsModule(consentResource);
